import { AxInit } from "../Lib/AxSystem/AxInit";
import { BodyUtility } from "../Components/AxUtility/BodyUtility";
import { ModuleName } from "../Lib/AxSystem/AxInit";

@ModuleName("AxFilterOverlay")
export class AxFilterOverlay implements AxInit {
    constructor(private _bodyUtility = new BodyUtility()) { }

    AxInit(init): void {
        $('body').on('click', '[data-toggle="filterBar"]', e => {
            if ($('.filter_bar').hasClass('active')) {
                this.toggleFilterBar(false);
            }
            window.scrollTo(0, 0);
            this.toggleFilterBar(true);
        });

        $('.filter_bar .filter_bar-close').click(e => {
            this.toggleFilterBar(false);
        });
    }

    toggleFilterBar(active: boolean) {
        $('.filter_bar').toggleClass('active', active);

        if (active) {
            this._bodyUtility.enableOverlay();
        } else {
            this._bodyUtility.disableOverlay();
        }
    }
}